// Returns the value of the option flagged as the parameter's default, in the form the
// report parameter fields expect: Boolean parameters hold a lower-cased "true"/"false".
function getParameterDefaultValue(reportParameter) {
	if (reportParameter.options == null || reportParameter.options.length === 0) {
		return null;
	}

	const defaultOption = reportParameter.options.find(function (option) {
		return option.default;
	});

	if (defaultOption == null) {
		return null;
	}

	if (reportParameter.parameterType.key === "Boolean") {
		return defaultOption.value.toLowerCase();
	}

	return defaultOption.value;
}

export const ReportHelperFunctions = {
	getParameterDefaultValue: getParameterDefaultValue
};
